
import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Channel } from "types";



export default function UpdateDetails({
    channel,
}: {
    channel: Channel;
}) {
    const [[name, setName], [nameError, setNameError]] = [useState(channel.name), useState("")];
    const [[description, setDescription]] = [useState(channel.description), useState("")];
    const [[additionalData, setAdditionalData]] = [useState(channel.additionalData), useState({
        streamChannel: "",
        streamPlatform: "twitch",
    })];
    const [isNSFW, setIsNSFW] = useState(channel.nsfw);
    const [isUpdateButtonDisabled, setIsUpdateButtonDisabled] = useState(true);
    useEffect(() => {
        if(channel.nsfw === isNSFW) {
            setIsUpdateButtonDisabled(false);
        } else {
            setIsUpdateButtonDisabled(true);
        }

        if (String(name?.trim()).length === 0 || String(name.trim()).length > 20) {
            setNameError("Channel name must be at least 1 character long and less than 20 characters long");
            setIsUpdateButtonDisabled(true);
        } else {
            setNameError("");
            setIsUpdateButtonDisabled(false);
        }

        if (channel.type === "watchstream") {
            if (additionalData && additionalData.streamChannel && (additionalData.streamChannel.trim() === "" || additionalData.streamChannel.length < 4 || additionalData.streamChannel.length > 25)) {
                setIsUpdateButtonDisabled(true);
            } else {
                setIsUpdateButtonDisabled(false);
            }
        }

    }, [name, additionalData?.streamChannel, isNSFW]);
    const UpdateButton = async () => {
        if (isUpdateButtonDisabled) return;
        setIsUpdateButtonDisabled(true);
        const response = await fetch(`__SITE_BASE__/api/v1/teams/${channel.teamId}/channels/${channel.id}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                name,
                description,
                type: channel.type,
                additionalData: channel.type === "watchstream" ? additionalData : {},
                nsfw: isNSFW,
            }),
        });

        if (!response.ok) {
            const data = await response.json();
            setNameError(data.message);
            setIsUpdateButtonDisabled(false);
        }
    };

    return (
        <>
            <div className="gap-4 flex flex-col py-6  items-start justify-start">
                {nameError && <p className="text-red-500">{nameError}</p>}
                <Label className="text-gray-300">Channel Name</Label>

                <Input
                    className="rounded-lg bg-brand-darkest border-0"
                    placeholder="Channel Name"
                    type="text"
                    value={name}
                    autoComplete="false"
                    onChange={(e) => setName(e.target.value)}
                />

                {channel.type === "watchstream" && (
                    <>
                        <Label className="text-gray-300">
                            Twitch Username
                        </Label>
                        <Input
                            className="rounded-lg bg-brand-darkest border-0"
                            placeholder="Twitch Username"
                            type="text"
                            autoComplete="false"
                            value={additionalData?.streamChannel}
                            onChange={(e) => setAdditionalData({ ...additionalData, streamChannel: e.target.value, streamPlatform: additionalData?.streamPlatform! } as any)}
                        />
                    </>
                )}

                <Label className="text-gray-300">Channel Description</Label>
                <textarea
                    className="rounded-lg bg-brand-darkest border-0 h-20 p-2 w-full resize-none border-brand-green text-gray-300 font-semibold placeholder-gray-500 focus:outline-none"
                    style={{
                        scrollbarWidth: "none",
                    }}
                    placeholder="Channel Description"
                    autoComplete="false"
                    onChange={(e) => setDescription(e.target.value)}
                    {...(description && { value: description })}
                />

                <div className="flex w-96">
                    <div className="flex justify-between items-center w-full">
                        <div className="flex flex-col">
                        <label
                            htmlFor="nsfw"
                            className="text-gray-300 font-semibold"
                        >
                            NSFW
                        </label>
                        <p className="text-gray-400 text-sm">
                            This channel contains <strong className="text-red-400">NSFW</strong> content
                        </p>
                        </div>

                        <div className="flex">
                            <div
                                className="relative inline-flex items-center cursor-pointer"
                                onClick={() => {
                                    setIsNSFW(!isNSFW);
                                }}
                            >
                                <input
                                    type="checkbox"
                                    className="sr-only"
                                    onChange={() => setIsNSFW(!isNSFW)}
                                    checked={isNSFW}
                                />
                                <div
                                    className={`block w-14 h-8 rounded-full ${isNSFW ? 'bg-brand-green' : 'bg-brand-profile'}`}
                                >
                                    <div
                                        className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${isNSFW ? 'translate-x-6' : 'translate-x-0'}`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  <div className="flex items-end justify-end mt-2">
                    <Button
                        className="bg-brand-green px-5 py-2 rounded-lg text-white font-semibold hover:bg-green-500"
                        disabled={isUpdateButtonDisabled}
                        onClick={UpdateButton}
                    >
                        Update
                    </Button>
                </div>
            </div>
        </>
    );
}